import React from 'react';

import { createClassName } from 'utils/createClassName';

import './underlinedTextStyles.scss';

type Props = {};

export const UnderlinedTextComponent: React.FC<Props> = (props) => {
  const { children } = props;

  const className = createClassName('underlinedText')();

  return <div className={className}>{children}</div>;
};
